import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="#D7D7FF" {...props}>
      <title>{props.title || 'Uniq'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path d="M24 0C37.2857 0 48 10.7143 48 24C48 37.2857 37.2857 48 24 48C10.7143 48 0 37.2857 0 24C0 10.7143 10.7143 0 24 0Z" />
        <rect
          x="12.25"
          y="12.25"
          width="9.25"
          height="9.24975"
          rx="1"
          stroke="white"
          strokeWidth="2.1"
        />
        <path
          d="M16.875 36.7498L16.0593 35.9948C13.1626 33.3225 11.25 31.5598 11.25 29.3979C11.25 27.6352 12.6117 26.25 14.3445 26.25C15.3237 26.25 16.262 26.714 16.875 27.4457C17.488 26.714 18.428 26.25 19.4055 26.25C21.1383 26.25 22.5 27.6352 22.5 29.3979C22.5 31.5614 20.5874 33.3241 17.6907 36.0015L16.875 36.7498Z"
          fill="white"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="26.5"
          y="12.25"
          width="9.25"
          height="9.24975"
          rx="1"
          stroke="white"
          strokeWidth="2.1"
        />
        <rect
          x="26.5"
          y="26.5"
          width="9.25"
          height="9.24975"
          rx="1"
          stroke="white"
          strokeWidth="2.1"
        />
      </g>
    </Icon>
  )
}
